export const STARTER_PRICE = 'Contact us'
export const GROWTH_PRICE = 'Contact us'
export const ENTERPRISE_PRICE = 'Contact us'

export const ENTERPRISE_CONTACT_EMAIL = 'support@fibrecraft.org'

export const PLANS = [
  {
    name: 'Starter',
    price: STARTER_PRICE,
    ctaLabel: 'Start free trial',
    featured: false,
    description: 'For small teams getting visibility for the first time.',
    features: [
      'Up to 20 employees',
      'Core task management',
      'Basic analytics',
      'Email notifications',
      'PDF/Excel export',
    ],
  },
  {
    name: 'Growth',
    price: GROWTH_PRICE,
    ctaLabel: 'Start free trial',
    featured: true,
    description: 'For growing organisations who need departmental insight.',
    features: [
      'Up to 100 employees',
      'Everything in Starter',
      'Department grouping',
      'Advanced analytics & rankings',
      'Innovation module',
      'Task templates',
    ],
  },
  {
    name: 'Enterprise',
    price: ENTERPRISE_PRICE,
    ctaLabel: 'Talk to us',
    featured: false,
    description: 'For large orgs with multi-level management hierarchies.',
    features: [
      'Unlimited employees',
      'Everything in Growth',
      'Multi-level managers',
      'Cross-manager analytics',
      'Audit logs',
      'Priority support',
      'SSO + 2FA',
    ],
  },
] as const
